import React from 'react';
import {VstButton, VstHeader, VstLilHead, VstLilHeadUser, VstLilHeadFooter, VstLilHeadListLink, VstLilHeadList} from 'vstui';
import UserAction from '../actions/user-action';
import UserStore from '../stores/user-store';
import UtilityStore from '../stores/utility-store';
import Dispatcher from '../dispatcher';

export default class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      user: UserStore.get(),
      activeHamburger: UtilityStore.get(UtilityStore.HAMBURGER_STATE)
    };

    this._handleUserChange = this._handleUserChange.bind(this);
    this._handleHamburgerChange = this._handleHamburgerChange.bind(this);
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
    Dispatcher.on(Dispatcher.HEADER_HAMBURGER_CHANGE, this._handleHamburgerChange);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
    Dispatcher.removeListener(Dispatcher.HEADER_HAMBURGER_CHANGE, this._handleHamburgerChange);
  }

  _handleUserChange() {
    this.setState({user: UserStore.get() });
  }

  _handleHamburgerChange() {
    this.setState({activeHamburger: UtilityStore.get(UtilityStore.HAMBURGER_STATE)});
  }

  _clickLogo(e) {
    e.preventDefault();
    Routes.setRoute('/');
  }

  _clickHamburger(e) {
    Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_TOGGLE);
  }

  _clickSignOut(e) {
    UserAction.signOut();
  }

  render() {

    // Prevent errors when user is not yet loaded
    let firstName = this.state.user ? this.state.user.firstName : "";
    let lastName = this.state.user ? this.state.user.lastName : "";
    let email = this.state.user ? this.state.user.email : "";
    let ssoOnly = this.state.user && this.state.user.ssoOnly;

    let logo = require('../../img/account_center_logo.svg');
    if (Mulligan.Brand.Graphics.logo !== "/img/logo_bookshelf.svg"){
      const url = document.createElement("a");
      url.href = Mulligan.Brand.Graphics.logo;
      logo = Mulligan.Brand.Graphics.logo;
    }

    return (
      <VstHeader className={classNames("header", {"navigation-open": this.state.activeHamburger})}
                 logo={logo}
                 title="Account Center Home"
                 clickLogo={this._clickLogo}
                 activeHamburger={this.state.activeHamburger}
                 clickHamburger={this._clickHamburger}>
        {Mulligan.Brand.AccountCenter.Header.visible &&
          <VstLilHead>
            {!ssoOnly &&
              <VstLilHeadUser firstName={firstName}
                              lastName={lastName}
                              email={email} />
            }
            <VstLilHeadList>
              {Mulligan.Brand.Bookshelf.visible && <VstLilHeadListLink icon="bookshelf" target="_blank" href={Mulligan.Brand.endpoint}>{Mulligan.Brand.brand}</VstLilHeadListLink>}
              {Mulligan.Brand.Support.visible && <VstLilHeadListLink icon="support" target="_blank" href={Mulligan.Brand.Support.url}>{i18n.t('base.support')}</VstLilHeadListLink>}
            </VstLilHeadList>
            <VstLilHeadFooter>
              <VstButton className="sign-out" options="btn-28" onClick={this._clickSignOut}>{i18n.t('base.sign-out')}</VstButton>
            </VstLilHeadFooter>
          </VstLilHead>
        }
      </VstHeader>
    );
  }
};
